const FIRST_LOGIN_SENT_KEY_PREFIX = 'user_first_login_sent:';

export const buildFirstLoginSentKey = (userId: string): string => `${FIRST_LOGIN_SENT_KEY_PREFIX}${userId}`;

export const claimFirstLoginSend = (userId: string): boolean => {
  if (typeof window === 'undefined') return false;

  try {
    const key = buildFirstLoginSentKey(userId);
    if (window.localStorage.getItem(key) !== null) return false;

    window.localStorage.setItem(key, 'true');
    return true;
  } catch {
    return false;
  }
};
